/* eslint-disable prettier/prettier */
import { StatusCodes } from "http-status-codes";
import { request } from "../../api";
import { headers } from "../../../../config/config";
import { MESSAGE } from "../../../../constants/api/message";
import { AUTHORIZATION } from "../../../../constants/api/auth";
const { post, get } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "registration";

// eslint-disable-next-line arrow-parens
export const memberSignUp = async (_payload) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/member-signup`;
		const response = await post(endpoint, payload, headers);
		if (response) {
			const {
				data: { message }
			} = response;

			if (message === MESSAGE.put.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (message === "Invalid Email!") {
				alert("Invalid Email!");
			} else if (message === "Email is already registered!") {
				alert("Email is already registered!");
			} else if (message === "Invalid User Name!") {
				alert("Invalid User Name!");
			} else if (message === "Username is already registered!") {
				alert("Username is already registered!");
			} else if (message === "SSN is already registered!") {
				alert("SSN is already registered!");
			} else if (message === "Member is already registered!") {
				alert("Member is already registered!");
			} else if (message === "Member has not been created yet!") {
				alert("Member has not been created yet!");
			} else if (message === MESSAGE.none) {
				alert("No Such Data");
			} else if (message === MESSAGE.put.fail) {
				alert("Failed to edit data");
			} else alert("Other Errors of Status Code 400");
		} else {
			throw error;
		}
	}
};
